import React from "react";
import { IoAdd } from "react-icons/io5";
import { FamilyMemberPicker } from "../components/FamilyMemberPicker";
import { ITranslations } from "../data/strings";
import { IFamilyMember } from "../models/IFamily";
import {
    AAPMediaToolkitCurrentUserChild,
    AAPMediaToolkitCurrentUserInfo,
    ELCID,
    IMediaToolkitNavPage,
} from "../models/IMediaToolkit";

export interface IFamilyConfigPageProps extends IMediaToolkitNavPage {
    currentUser?: AAPMediaToolkitCurrentUserInfo;
    translations: ITranslations;
    addMember: () => void;
    updateMember: (data: IFamilyMember, idx: number) => void;
    deleteMember: (idx: number) => void;
    updateFamilyName: (name: string) => void;
    addMembersFromAAPAccount: () => void;
    isAccountMemberAdded: (accountMember: AAPMediaToolkitCurrentUserChild) => boolean;
}

export const FamilyConfigPage: React.FunctionComponent<IFamilyConfigPageProps> = (props) => {
    const membersNotAdded: number = (props.currentUser?.Children || []).filter(
        (accountMember) => !props.isAccountMemberAdded(accountMember)
    ).length;

    return (
        <>
            <div className="card-header bg-aap-creamy-gray-500 text-aap-dk-red-500 px-5 xl:px-10 py-5 pt-10">
                <div>
                    <h1 className="text-4xl mb-5">{props.title}</h1>
                    <div className="text-sm" dangerouslySetInnerHTML={{ __html: props.description }}></div>
                </div>
            </div>
            <div className="card-body bg-aap-cream-500 p-5 pt-0 xl:p-10 xl:pt-0">
                {props.ctaMap}
                <div className="w-full max-w-lg mx-auto py-5 pl-5 md:pl-28 bg-family-name-bg bg-left bg-contain bg-no-repeat">
                    <small className="block mb-2">{props.translations.enterFamilyName} *</small>
                    <input
                        type="text"
                        className={`text-2xl border-2 rounded-md w-full p-2 ${!props.family.name ? `border-aap-red-500` : `border-aap-green-500`}`}
                        value={props.family.name || ""}
                        disabled={props.readonly}
                        onChange={(ev) => {
                            props.updateFamilyName(ev.target.value);
                        }}
                    />
                </div>
                <hr className="my-3 border-aap-gray-200" />
                <h3 className="text-xl pb-3">{props.translations.myFamily}</h3>
                {!props.readonly ? (
                    <>
                        <button
                            type="button"
                            onClick={props.addMember}
                            className="border border-aap-red-500 text-aap-red-500 bg-white hover:bg-aap-red-500 hover:text-white text-sm py-1 px-2 rounded-sm mr-3 mb-3"
                            id={`btn_addFamilyMember_${ELCID[props.lcid]}`}
                        >
                            <IoAdd size={16} className="inline" /> {props.translations.addAnotherFamilyMember}
                        </button>
                        {membersNotAdded > 0 ? (
                            <button
                                type="button"
                                onClick={props.addMembersFromAAPAccount}
                                className="border border-aap-red-500 text-aap-red-500 bg-white hover:bg-aap-red-500 hover:text-white text-sm py-1 px-2 rounded-sm mr-3"
                                id={`btn_addFamilyMembersFromAAPAccount_${ELCID[props.lcid]}`}
                            >
                                <IoAdd size={16} className="inline" /> {props.translations.addMembersFromAAPAccount}
                            </button>
                        ) : null}
                    </>
                ) : null}
                <div className="mb-3 mt-5">
                    {props.family.members.map((member, idx) => {
                        return (
                            <FamilyMemberPicker
                                familyMember={member}
                                index={idx}
                                key={`familymember-${idx}`}
                                updateMember={props.updateMember}
                                deleteMember={props.deleteMember}
                                removable={props.family.members.length > 1}
                                readonly={props.readonly}
                                lcid={props.lcid}
                                translations={props.translations}
                            />
                        );
                    })}
                </div>
                {!props.readonly ? (
                    <button
                        type="button"
                        onClick={props.addMember}
                        className="border border-aap-red-500 text-aap-red-500 bg-white hover:bg-aap-red-500 hover:text-white text-sm py-1 px-2 rounded-sm"
                        id={`btn_addFamilyMember_${ELCID[props.lcid]}`}
                    >
                        <IoAdd size={16} className="inline" /> {props.translations.addAnotherFamilyMember}
                    </button>
                ) : null}
                {props.footer ? (
                    <div className="pt-10">
                        <div dangerouslySetInnerHTML={{ __html: props.footer || "" }}></div>
                    </div>
                ) : null}
                <div className="mobileNav py-2 flex justify-between lg:hidden">
                    {props.backButton}
                    {props.continueButton}
                </div>
            </div>
        </>
    );
};
